import { getAdobeAccessToken } from '../auth/adobeIms';
import { actionUrl } from './database';
export interface FeedbackPayload {
  messageId: string;
  rating: 'up' | 'down';
  comment?: string;
  query?: string;
  mode: 'nlq' | 'workfront';
}
function getAuthHeaders(): Record<string, string> {
  const token = getAdobeAccessToken();
  return {
    'Content-Type': 'application/json',
    ...(token ? {
      Authorization: `Bearer ${token}`
    } : {})
  };
}
export async function submitFeedback(payload: FeedbackPayload): Promise<boolean> {
  try {
    // console.log('[Feedback] Submitting:', payload);
    const resp = await fetch(actionUrl('submit-feedback'), {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(payload)
    });
    const body = await resp.json().catch(() => ({}));
    // console.log('[Feedback] Response:', resp.status, body);

    return resp.ok;
  } catch (err) {
    console.error('[Feedback] Submit error:', err);
    return false;
  }
}